module.exports = __webpack_public_path__ + "static/media/voluntary.8d421d65.ogg";